import { Controller } from "@hotwired/stimulus"

// Controller for changing the number of selected recipients in the engagement page.
export default class extends Controller {
  static get targets() {
    return ["selected", "total"]
  }

  updateSelectedRecipientsNumber({ detail: { checked } }) {
    this.selectedTarget.innerText = checked
  }
}
